<div >
    <nb-card>
        <nb-card-header>
            Edit Metadata
        </nb-card-header>
        <nb-card-body>
        
            <form #editmetadataForm="ngForm" autocomplete="off" class="form-horizontal edit-metadata-content {{from_height}}" novalidate
                (submit)="Save(editmetadataForm.value, editmetadataForm.valid)" (keydown.enter)="$event.preventDefault()">
                <div class="row" >
                    <div class="col-12">
                        <div class="form-group row">
                            <label class="col-12 label col-form-label ">Title:</label>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <input type="text" autocomplete="off" class="form-control" nbInput fullWidth
                                    maxlength="40" placeholder="Title" name="title" [(ngModel)]="_data.title"  #title="ngModel"  required/>
                                        <div class="text alert alert-danger" *ngIf="(submitted && !title.valid) || (title.touched && !title.valid)">
                                            <div *ngIf="title.errors.required">Title is required</div>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="form-group row">
                            <label class="col-12 label col-form-label">Tag:</label>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <nb-tag-list (tagRemove)="onTagRemove($event)">
                                        <nb-tag
                                            *ngFor="let tag of tags"
                                            [text]="tag"
                                            removable>
                                        </nb-tag>

                                        <input
                                            type="text"
                                            nbTagInput
                                            autocomplete="off"
                                            [placeholder]="tags.length >= maxTags ? '' : 'Add a tag'"
                                            (keydown.enter)="preventEnter($event)"
                                            [disabled]="tags.length >= maxTags"
                                            (tagAdd)="onTagAdd($event)"
                                            (input)="clearTagError()"
                                            nbInput
                                            fullWidth>
                                    </nb-tag-list>

                                    <!-- Error Message -->
                                    <div class="text alert alert-danger" *ngIf="tagError">
                                        {{ tagError }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="form-group" [ngClass]="{'has-error': description.touched && description.errors}">
                            <label class="label col-form-label">Description:</label>
                            <textarea nbInput rows="4" id="description" name="description" [(ngModel)]="_data.description" 
                            maxlength="250" fullWidth placeholder="Description"  #description="ngModel"></textarea>
                        </div>
                    </div>
                    
                    <div class="col-12 buttons-row">
                        <button id="btnSubmit" type="submit" [disabled]="!title.valid" nbButton status="primary">SUBMIT</button>

                        <button id="btnCancel" nbButton status="danger" (click)="onCancel()">CANCEL</button>
                    </div>
                </div>

            </form>
        </nb-card-body>
    </nb-card>
</div>